import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, Type } from '@angular/core';

export interface ITab {
  label: string;
  component: TemplateRef<any>;
  context?: any
}

@Component({
    selector: 'app-tab-control',
    templateUrl: './tab-control.component.html',
    styleUrls: ['./tab-control.component.scss'],
    imports: [CommonModule]
})
export class TabControlComponent implements OnInit {
  @Input() id?: string;
  @Input() tabs: ITab[] = [];

  selectedTabIndex = 0;

  ngOnInit() {
    if (this.tabs.length > 0) {
      this.selectedTabIndex = 0;
    }
  }

  selectTab(index: number) {
    this.selectedTabIndex = index;
  }
}
